import { DjangoTimeStamped, TimeStamped } from '../django';
import { parseDate } from '../helpers/date';

export class EmployerPayrollSettings implements TimeStamped {
  id: string;
  transitoryAccountUuid: string;
  checkingAccountUuid: string;
  accountNumber: string;
  branchNumber: string;
  communicationEmail: string;
  accountCnpj: string;
  // DJANGO TIMESTAMPED
  created: Date;
  modified: Date;

  constructor(data: string | EmployerPayrollSettings | DjangoEmployerPayrollSettings = {}) {
    if (data instanceof EmployerPayrollSettings) {
      bindEmployerPayrollSettingsData(this, data);
    } else if (typeof data === 'string') {
      bindDjangoEmployerPayrollSettingsData(this, { id: data });
    } else {
      bindDjangoEmployerPayrollSettingsData(this, data);
    }
  }

  get djangoModel() {
    return getDjangoModel(this);
  }
}

export function parseEmployerPayrollSettings(data?: string | EmployerPayrollSettings | DjangoEmployerPayrollSettings) {
  if (data) {
    return new EmployerPayrollSettings(data);
  } else {
    return undefined;
  }
}

function bindEmployerPayrollSettingsData(instance: EmployerPayrollSettings, data: EmployerPayrollSettings) {
  instance.id = data.id;
  instance.transitoryAccountUuid = data.transitoryAccountUuid;
  instance.checkingAccountUuid = data.checkingAccountUuid;
  instance.accountNumber = data.accountNumber;
  instance.branchNumber = data.branchNumber;
  instance.communicationEmail = data.communicationEmail;
  instance.accountCnpj = data.accountCnpj;
  // DJANGO TIMESTAMPED
  instance.created = data.created;
  instance.modified = data.modified;
}

//////////////////////
/// DJANGO SUPPORT ///
//////////////////////
export interface DjangoEmployerPayrollSettings extends DjangoTimeStamped {
  id?: string;
  transitory_account_uuid?: string;
  checking_account_uuid?: string;
  account_number?: string;
  branch_number?: string;
  communication_email?: string;
  account_cnpj?: string;
  // DJANGO TIMESTAMPED
  created?: string;
  modified?: string;
}

function bindDjangoEmployerPayrollSettingsData(instance: EmployerPayrollSettings, data: DjangoEmployerPayrollSettings) {
  instance.id = data.id;
  instance.transitoryAccountUuid = data.transitory_account_uuid;
  instance.checkingAccountUuid = data.checking_account_uuid;
  instance.accountNumber = data.account_number;
  instance.branchNumber = data.branch_number;
  instance.communicationEmail = data.communication_email;
  instance.accountCnpj = data.account_cnpj;
  // DJANGO TIMESTAMPED
  instance.created = parseDate(data.created);
  instance.modified = parseDate(data.modified);
}

function getDjangoModel(instance: EmployerPayrollSettings) {
  return {
    id: instance.id,
    transitory_account_uuid: instance.transitoryAccountUuid,
    checking_account_uuid: instance.checkingAccountUuid,
    account_number: instance.accountNumber,
    branch_number: instance.branchNumber,
    communication_email: instance.communicationEmail,
    account_cnpj: instance.accountCnpj,
  };
}
